export default function OrdemCompra(){
    return "Ordem compra"
}